namespace $ { $mol_style_attach( "visavis/phase/phase.view.css",
 "path{pointer-events:painted;}\ng{pointer-events:painted;}\n"
) }